import { ReactNode } from 'react';

import cx from 'classnames';

import s from './CircleIcon.module.scss';

interface IProps {
  children?: ReactNode;
  className?: string;
  colour?: 'yellow' | 'purple' | 'pink';
}

const CircleIcon: React.FC<IProps> = ({ children, className = '', colour }) => (
  <div
    className={cx(s.item, className, {
      [s.yellow]: colour === 'yellow',
      [s.purple]: colour === 'purple',
      [s.pink]: colour === 'pink',
      [s.dark]: !colour,
    })}
  >
    {children}
  </div>
);

export default CircleIcon;
